import { useMutation } from "@tanstack/react-query";

import queryClient from "single-spa/react-app/query-client";

import type { IInitialKeywordGroup, IUserKeywordGroup } from "../keywordGroups.types";
import { createKeywordGroup, keywordGroupsKeys } from "../queries/keywordGroupsQueries";
import { keywordGroupsQueryClient } from "../utils/keywordGroupsQueryClient";

/**
 * @deprecated Use useCreateKeywordGroupApiClient from pro-api-client instead.
 * This hook will be removed in a future version.
 * New implementations should use the API client version for better type safety and consistency.
 */
export const useCreateKeywordGroup = () => {
    return useMutation<IUserKeywordGroup | undefined, Error, IInitialKeywordGroup>({
        mutationFn: async (group) => {
            await createKeywordGroup(group);
            await queryClient.invalidateQueries({ queryKey: keywordGroupsKeys.user() });
            const newGroupList = await keywordGroupsQueryClient.getUserGroups();
            const newGroup = newGroupList.find((g) => g.Name === group.Name);
            return newGroup;
        },
    });
};
